import CheckIcon from "@bmi-digital/components/icon/Check";
import { styled } from "@mui/material/styles";

export const StyledBlueCheckIconInter = styled(CheckIcon)(({ theme }) => ({
  color: theme.colours.inter
}));
